"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskModel = void 0;
/* eslint-disable max-len */
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const TaskStatus_1 = __importDefault(require("@opsbase/lib-task/TaskStatus"));
const TaskType_1 = __importDefault(require("@opsbase/lib-task/TaskType"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const Model_1 = __importDefault(require("../Model"));
const ModelRegistry_1 = __importDefault(require("../ModelRegistry"));
class TaskModel extends Model_1.default {
    constructor(o) {
        super(o);
        this.type = TaskType_1.default.TASK_PURGE;
        this.status = TaskStatus_1.default.PRE_QUEUE;
        this.log = [];
        this.response = {};
        super.init(o);
    }
    get __typename() {
        return 'Task';
    }
    set __typename(v) {
    }
    get duration() {
        if (!this.startedDate || !this.completedDate)
            return '';
        return moment_timezone_1.default
            .duration((0, moment_timezone_1.default)(this.completedDate).diff((0, moment_timezone_1.default)(this.startedDate), 'seconds'), 'seconds')
            .humanize();
    }
    get isFinished() {
        const s = this.status;
        return s === TaskStatus_1.default.FAILURE || s === TaskStatus_1.default.SUCCESS;
    }
}
exports.TaskModel = TaskModel;
TaskModel.ALL_FIELDS = `id, title, type, status, config, log, response,
	createdDate,
	startedDate,
	completedDate
	`;
exports.default = TaskModel;
ModelRegistry_1.default[DataType_1.default.TASK] = TaskModel;
